<template>
  <div>
    <EditRecurringEventForm
      :initial-form-data="recurringEvent"
      :on-form-saved="onRecurringEventSaved"
    />
    <b-button
      variant="outline-danger"
      :disabled="isSubmitting"
      @click="deleteRecurringEvent"
    >
      Delete
    </b-button>
  </div>
</template>

<script>
import EditRecurringEventForm from '@/views/pages/locations/EditRecurringEventForm.vue'
import store from '@/store'
import { BButton, BModal } from 'bootstrap-vue'
import AccountService from '@/services/AccountService'

export default {
  components: {
    EditRecurringEventForm,
    BButton,
    BModal,
  },
  props: [
    'locationId',
    'recurringEventId',
  ],
  data() {
    return {
      isSubmitting: false,
      recurringEvent: store.getters['auth/recurringEventById'](this.locationId, this.recurringEventId),
    }
  },
  created() {
  },
  methods: {
    onRecurringEventSaved(apiResponse) {
      const self = this
      store.dispatch('auth/getAuthUser')
        .then(() => {
          // after saving a new location, redirect to its edit for where all the other options like services are
          self.$router.push({
            name: 'edit-location',
            params: { id: apiResponse.data.location_id },
          })
        })
    },
    async showConfirmDeleteModal() {
      const numberOfVisitors = await this.getNumberOfServiceVisitors()
      let message = 'Are you sure you want to delete this recurring service?'
      if (numberOfVisitors && numberOfVisitors.length > 0) {
        message = `Are you sure you want to delete? There are ${numberOfVisitors.length} visitors scheduled for this service, their data will be preserved in contacts`
      }
      return this.$bvModal.msgBoxConfirm(message, {
        title: 'Please Confirm',
        size: 'sm',
        okVariant: 'primary',
        okTitle: 'Yes',
        cancelTitle: 'No',
        cancelVariant: 'outline-secondary',
        hideHeaderClose: false,
        centered: true,
      })
    },
    async getNumberOfServiceVisitors() {
      return AccountService.getRecurringServiceVisitorsCount(this.recurringEventId).then(res => res.data.data)
    },
    async deleteRecurringEvent() {
      this.showConfirmDeleteModal()
        .then(async value => {
          if (value) {
            this.isSubmitting = true
            try {
              const self = this
              await AccountService.deleteRecurringEvent(this.recurringEventId)
              store.dispatch('auth/getAuthUser').then(() => {
                self.$router.push({
                  name: 'edit-location',
                  params: { id: self.locationId },
                })
              })
            } catch (error) {
              console.error(error)
            } finally {
              this.isSubmitting = false
            }
          }
        })
    },
  },
}
</script>
